import { useEffect, useMemo, useState } from 'react'
import Pages from '../../../../const/Pages'
import { userSelector, setUserRoutine } from '../../../../store/global'
import { wordListsDataSelector } from '../../../../store/wordLists'
import '../../../../styles/scss/dictionary/dictionary.scss'
import NewCommerceUtil from '../../../utils/NewCommerceUtil'
import WordLists from './wordlists/WordLists'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { selectCardList } from '../../../helpers/card-list-helper'
import { wordsDataSelector } from '../../../../store/words'
import AddWordListButton from './wordlists/AddWordListButton'
import Constants from '../../../../const/Constants'
import { isPremium } from '../../../../common/utils/user'
import { Flex, Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { fetchWorldLists } from '../../../../store/wordLists/extraReducers'

const DictionaryMyLists = () => {
    const user = useAppSelector(userSelector)
    const wordLists = useAppSelector(wordListsDataSelector)
    const cards = useAppSelector(wordsDataSelector)
    const [search, setSearch] = useState('')

    const dispatch = useAppDispatch()
    useEffect(() => {
        updateUserIfNew()
        dispatch(fetchWorldLists())
        return cancelAllWorListChanges()
    }, [])

    const updateUserIfNew = () => {
        const newUser = NewCommerceUtil.showNewCommerceModal(user, Pages.DICTIONARY)
        if (newUser) {
            dispatch(setUserRoutine(newUser))
        }
    }

    const cancelAllWorListChanges = () => {
        selectCardList(dispatch, 'null-list', wordLists, cards)
    }

    const isNotInEditMode = () => {
        return !wordLists.some((wl: any) => wl.editMode)
    }
    const canAddUser = () => {
        const userWordLists = wordLists.filter((wl: any) => !wl.communityId)
        return userWordLists.length < Constants.MAX_AMOUNT_WORD_LISTS || isPremium(user)
    }

    const filteredLists = useMemo(() => {
        if (!search.trim()) return wordLists
        const q = search.trim().toLowerCase()
        return wordLists.filter((wl: any) =>
            wl.listName?.toLowerCase().includes(q)
        )
    }, [wordLists, search])

    return (
        <div className='dictionary' id='dictionary'>
            <Flex gap={12} align='center' wrap='wrap' className='dictionary_btn'>
                {isNotInEditMode() &&
                <AddWordListButton canAddUser={canAddUser()} />}
                <Input
                    placeholder='Найти список...'
                    prefix={<SearchOutlined style={{ color: 'var(--color-text-muted)' }} />}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    allowClear
                    style={{ maxWidth: 280 }}
                />
            </Flex>

            <div className='dictionary_container'>
                <WordLists
                    wordLists={filteredLists}
                    user={user}
                    isCommunity={false}
                    canEditCommunity={false}
                />
            </div>
        </div>
    )
}
export default DictionaryMyLists
